import React, { FC, useCallback, useEffect } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { useDispatch } from 'react-redux'
import { USER_IDLE_TIMEOUT } from '../../constants/ActiveSession'
import { logoutRequest } from '../../store/actions'

export const UserActiveSession: FC = ({ children }) => {
  const dispatch = useDispatch()

  const handleOnIdle = useCallback(() => dispatch(logoutRequest()), [dispatch])

  const { reset } = useIdleTimer({
    timeout: USER_IDLE_TIMEOUT,
    onIdle: handleOnIdle,
    stopOnIdle: true,
  })

  useEffect(() => {
    reset()
    // eslint-disable-next-line
  }, [])

  return <>{children}</>
}
